import { Nexus } from '@tomandco/nexus-api-types';

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib {
        namespace Catalog {
            namespace Model.Product.Data {
                interface V3 {
                    am_open_amount_min?: number;
                    am_open_amount_max?: number;
                    am_giftcard_prices?: number[];
                    am_giftcard_type?: number;
                    am_giftcard_code_image?: number[];
                }
            }

            namespace Model.Category.Data {
                interface V3 {
                    pageTemplate?: string;
                }
            }
        }

        namespace Basket {
            interface BasketData {
                giftcards?: Giftcards.IAddedGiftcardData[];
            }

            interface Totals {
                giftcards?: number;
            }
            interface AddToBasketData {
                am_giftcard_message?: string;
            }
        }
    }
}

export namespace Giftcards {
    export const giftcardTypeId = 'amgiftcard';

    export enum Type {
        Virtual = 1,
        Printed,
        Combined
    }

    export enum VirtualType {
        SendToMe = 'send_to_me',
        SendToAnother = 'send_to_another'
    }

    export enum Endpoints {
        Balance = 'giftcard/balance',
        Add = 'giftcard/add',
        Remove = 'giftcard/remove',
        CheckoutAdd = 'checkout/giftcardAdd',
        CheckoutRemove = 'checkout/giftcardRemove'
    }

    export interface IAddToBasketData extends Nexus.Lib.Basket.AddToBasketData {
        am_giftcard_amount?: number;
        am_giftcard_amount_custom?: number;
        am_giftcard_date_delivery?: Date | string;
        am_giftcard_image?: number;
        am_giftcard_message?: string;
        am_giftcard_recipient_email?: string;
        am_giftcard_recipient_name?: string;
        am_giftcard_sender_email?: string;
        am_giftcard_sender_name?: string;
        recipientType?: ERecipientType;
        is_send_to_myself?: 1 | 0;
    }

    export enum ERecipientType {
        myself,
        recipient
    }

    export interface IAddedGiftcardData {
        code: string;
        balance: number;
        amount: number;
        balance_after_purchase: number;
    }

    export interface IBalanceCheckData {
        code: string;
        pin?: string;
    }

    export interface IBalanceCheckResponse {
        balance: number;
    }

    export interface IAddData {
        code: string;
        checkout?: boolean;
    }

    export interface IRemoveData extends IAddData {}
}
